import {
  GraduationCap,
  Briefcase,
  UtensilsCrossed,
  ShoppingBag,
  Plane,
  Bot,
  ArrowUpRight,
} from "lucide-react";
import { Reveal } from "../landing/Reveal";

const PRODUCTS = [
  {
    icon: GraduationCap,
    name: "LearnNova",
    desc: "Online Courses · Mentoring · Certifications",
    grad: "from-[#635BFF] to-[#8B85FF]",
  },
  {
    icon: Briefcase,
    name: "CareerNova",
    desc: "Jobs · Internships · Referrals",
    grad: "from-[#00D26A] to-[#4ADE80]",
  },
  {
    icon: UtensilsCrossed,
    name: "FoodNova",
    desc: "Cloud Kitchens · Student Chefs",
    grad: "from-[#FF7A00] to-[#FFB25E]",
  },
  {
    icon: ShoppingBag,
    name: "ShopNova",
    desc: "Fashion · Electronics · Books",
    grad: "from-[#EC4899] to-[#F472B6]",
  },
  {
    icon: Plane,
    name: "TravelNova",
    desc: "Flights · Hotels · Bus",
    grad: "from-[#06B6D4] to-[#67E8F9]",
  },
  {
    icon: Bot,
    name: "Funz AI",
    desc: "Career Coach · Learning Guide · Financial Assistant",
    grad: "from-[#635BFF] to-[#00D26A]",
  },
];

export const ProductsGrid = () => (
  <section id="products" data-testid="products-section" className="relative py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center">
        <p className="font-jbmono text-xs uppercase tracking-[0.3em] text-[#00D26A]">
          The Nova Family
        </p>
        <h2 className="mx-auto mt-4 max-w-2xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
          Everything in one app.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {PRODUCTS.map((p, i) => (
          <Reveal key={p.name} delay={0.06 * i}>
            <div
              data-testid={`product-card-${p.name.toLowerCase().replace(" ", "-")}`}
              className="group relative h-full overflow-hidden rounded-3xl border border-white/10 bg-[#111827] p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-[#635BFF]/50"
            >
              <div
                aria-hidden="true"
                className={`absolute -right-10 -top-10 h-32 w-32 rounded-full bg-gradient-to-br ${p.grad} opacity-[0.12] blur-2xl transition-opacity duration-300 group-hover:opacity-25`}
              />
              <span className={`flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br ${p.grad}`}>
                <p.icon className="h-5 w-5 text-white" />
              </span>
              <h3 className="mt-5 font-display text-xl font-bold text-white">{p.name}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-400">{p.desc}</p>
              <span className="mt-5 inline-flex items-center gap-1.5 font-jbmono text-[11px] font-bold uppercase tracking-widest text-slate-500 transition-colors group-hover:text-[#00D26A]">
                Explore
                <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
